module.exports = __webpack_public_path__ + "assets/images/card-pg-4_dc878412c58ac286555daa0ebe1c6996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/card-pg-4.png
// module id = 191
// module chunks = 0